import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import * as moment from "moment";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Spinner from "components/spinner";
import maleAvatar from "assets/images/avatar.jpg";
import avatar from "assets/images/avatar.jpg";
import "./styles.scss";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import { getAllParentCategoriesList } from "services/V2_APIs/DoctorsConsultationApis/parentCategories.service";
import {
  deleteCategory,
  getAllCategoriesList,
} from "services/V2_APIs/DoctorsConsultationApis/categories.service";
import View from "pages/Services/View";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import CreateCategory from "./Create";
import EditCategory from "./Edit";

const CategoriesMain = () => {
  const [parentCatList, setParentCatList] = useState(null);
  const [activeParentCatInd, setActiveParentInd] = useState(null);
  const [subCatList, setSubCatList] = useState(null);
  const [activeSubCatInd, setActiveSubCatInd] = useState(null);
  const [activeSubCat, setActiveSubCat] = useState(null);
  const [activeServiceInd, setActiveServiceInd] = useState(null);
  const [service, setService] = useState(null);
  const [activeService, setActiveService] = useState({});
  const [delete_modal, setDelete_modal] = useState(false);
  const [deleteId, setDeleteid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [Editmodal, setEditModal] = useState(false);

  const [selectedGender, setSelectedGender] = useState(null);

  const toggle = () => {
    setModal(!modal);
  };
  const EditToggle = () => {
    setEditModal(!Editmodal);
  };
  const genders = [
    {
      key: "male",
      label: "Male",
      image: maleAvatar,
    },
    {
      key: "female",
      label: "Female",
      image: maleAvatar,
    },
    {
      key: "unisex",
      label: "Unisex",
      image: maleAvatar,
    },
  ];

  const handleGenderSelect = gender => {
    setSelectedGender(gender);
    getParentCatList(gender);
    setSubCatList(null);
  };

  const getParentCatList = gender => {
    getAllParentCategoriesList()
      .then(res => {
        let filterData = res?.data?.filter(ele => ele?.genderType === gender);
        setParentCatList(filterData);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  const getCategoriesList = parentId => {
    getAllCategoriesList()
      .then(res => {
        if (res.data) {
          let filteredList = res?.data?.filter(
            ele => ele?.parentCategory === parentId
          );
          setSubCatList(filteredList);
        }
        setLoading(false);
        setActiveServiceInd(null);
      })
      .catch(e => {
        setLoading(false);
        console.log(e);
      });
  };

  const onClickDelete = () => {
    let selectedId = service._id;
    setDeleteid(selectedId);
    setDelete_modal(true);
  };

  const removeService = id => {
    setLoading(true);
    deleteCategory(id)
      .then(res => {
        setDelete_modal(false);
        // const selectedCategory = subCatList[activeSubCatInd];
        getCategoriesList(
          parentCatList[activeParentCatInd]?._id
            ? parentCatList[activeParentCatInd]?._id
            : {}
        );
      })
      .catch(err => {
        setLoading(false);
      });
  };
  const handleOnDelete = () => {
    removeService(deleteId);
  };

  const stayHere = () => {
    setDelete_modal(false);
  };

  const deletePopup = () => {
    return (
      <SweetAlert
        title="Are you sure ?"
        warning
        onConfirm={handleOnDelete}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={handleOnDelete}
            >
              Delete
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              cancel
            </Button>
          </React.Fragment>
        }
      >
        You will not be able to recover this record
      </SweetAlert>
    );
  };

  const handleSubCat = (ele, index) => {
    getCategoriesList(ele?._id);
    setActiveSubCatInd(index);
    setActiveSubCat(subCatList ? subCatList[index] : "");
    setActiveParentInd(index);
  };

  const handleService = (ele, index) => {
    setActiveServiceInd(index);
    setService(ele);
  };

  const renderParentCatList = () => {
    return (
      <Card className="border-dark">
        <CardBody className="p-0">
          {!parentCatList && (
            <div className="empty_list p-3 pt-0">
              <div className="text-center">
                <i className="mdi mdi-arrow-left-circle" id="nullCatList"></i>
              </div>
              <p className="text-center">Please Select Parent Category</p>
            </div>
          )}
          {parentCatList && parentCatList?.length === 0 && (
            <div className="empty_list p-3 pt-0">
              <div className="text-center">
                <i className="mdi mdi-circle-off-outline" id="EmptyCatList"></i>
              </div>
              <h4>Empty List</h4>
              <p className="text-center">No Categories Found</p>
            </div>
          )}

          {parentCatList &&
            parentCatList.map((ele, indx) => {
              return (
                <Card
                  key={indx}
                  className={
                    activeSubCatInd === indx
                      ? "mx-3 my-4 border-light active"
                      : "mx-3 my-4 border-light"
                  }
                  onClick={() => {
                    handleSubCat(ele, indx);
                  }}
                >
                  <img alt={ele.name} className="header_img" src={ele.image} />
                  <CardBody className="p-2">
                    <div className="card_title"> {ele.name}</div>
                    <div
                      className="mt-1 card_tagline"
                      dangerouslySetInnerHTML={{ __html: ele.tagline }}
                    />
                  </CardBody>
                </Card>
              );
            })}
        </CardBody>
      </Card>
    );
  };

  const renderBasicInfo = () => {
    return (
      <div className="m-3 services_basic_info">
        <Row>
          <div className="info_conetent_header d-flex justify-content-between mb-2 align-items-center">
            <div>
              {activeSubCatInd !== null &&
                subCatList &&
                subCatList.length > 0 && (
                  <div className="service_title" style={{ top: "0" }}>
                    {subCatList[activeServiceInd]["title"]}
                  </div>
                )}
            </div>
            <div className="d-flex">
              <Link
                className="btn btn-sm btn-primary btn-bg-primary me-3 "
                to="#"
                onClick={() => {
                  EditToggle();
                  setActiveService(service);
                }}
              >
                <i className="bx bx-edit-alt pe-1"> </i>
                <span className="py-3"> Edit</span>
              </Link>
              <Link
                className="btn btn-sm btn-danger btn-bg-danger "
                to="#"
                onClick={() => onClickDelete()}
              >
                <i className="bx bxs-trash-alt pe-1"></i>
                <span> Delete</span>
              </Link>
            </div>
          </div>
        </Row>
        <Row className="m-0">
          <Col md={4} className="services_images_info ps-0 pe-2">
            <Card className="mb-2">
              <CardBody>
                <Row className="mb-2"></Row>
                <div className="banner">
                  <img
                    alt="banner"
                    src={service?.images[0] ? service?.images[0] : avatar}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col md={8} className="p-0">
            <Card>
              <CardBody>
                <Row className="m-0">
                  <Col md={12} className="mb-1 px-0 view_detail">
                    <Row className="m-0 mb-2">
                      <Col md={4} className="mt-1">
                        <p className="fw-bold mb-1">Name</p>
                        <p className="text-muted">
                          {service.title ? service.title : "_"}
                        </p>
                      </Col>

                      <Col md={4} className="mt-1">
                        <p className="fw-bold mb-1">Status</p>
                        <p
                          className={
                            service.status === "Active"
                              ? "text-" + "success"
                              : "text-" + "danger"
                          }
                        >
                          {service?.status ? service.status : "_"}
                        </p>
                      </Col>
                      <Col md={4} className="">
                        <p className="fw-bold mb-1">Order</p>
                        <p className="text-muted">
                          {service?.order ? service.order : "_"}
                        </p>
                      </Col>
                    </Row>

                    <Row className="m-0 mb-2">
                      <Col md={4} className="mt-1">
                        <p className="fw-bold mb-1">Condition</p>
                        <p className="text-muted">
                          {service?.condition ? service?.condition : "_"}{" "}
                        </p>
                      </Col>
                      <Col md={4} className="mt-1">
                        <p className="fw-bold mb-1">Parent Category</p>
                        <p className="text-muted">
                          {service.parentCategory
                            ? service.parentCategory
                            : "_"}{" "}
                        </p>
                      </Col>
                    </Row>
                    <Row className="m-0 mb-2">
                      <Col md={12} className="mt-1">
                        <p className="fw-bold mb-1">Tagline</p>
                        {service.tagline ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: values.tagline,
                            }}
                          />
                        ) : (
                          "_"
                        )}{" "}
                      </Col>
                    </Row>
                    <Row className="m-0 mb-2">
                      <Col md={12} className="mt-1">
                        <p className="fw-bold mb-1">Description</p>
                        {service.description ? (
                          <div
                            className="text-muted"
                            dangerouslySetInnerHTML={{
                              __html: service.description,
                            }}
                          />
                        ) : (
                          "_"
                        )}{" "}
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col md={6} className="">
                        <Card className="services_images_info border border-2">
                          <CardBody className="">
                            <Row className="mb-2">
                              {" "}
                              <Col md={6}>
                                <p className="fw-bold mb-0">Images</p>{" "}
                              </Col>
                            </Row>

                            <div className="images_container justify-content-start">
                              {service?.images?.map(ele => {
                                return (
                                  <div className="img_card" key={ele}>
                                    <img src={ele} />
                                  </div>
                                );
                              })}
                              {service?.images?.length === 0 && (
                                <>
                                  <div className="img_card">
                                    <img src={avatar} />
                                  </div>
                                  <div className="img_card">
                                    <img src={avatar} />
                                  </div>
                                </>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md={6}>
                        <Card className="services_images_info border border-2">
                          <CardBody className="">
                            <Row className="mb-2">
                              {" "}
                              <Col md={6}>
                                <p className="fw-bold mb-0">Mobile Banners</p>{" "}
                              </Col>
                            </Row>

                            <div className="images_container justify-content-start">
                              {service?.mobileBanners?.map(ele => {
                                return (
                                  <div className="img_card" key={ele}>
                                    <img src={ele} />
                                  </div>
                                );
                              })}
                              {service?.mobileBanners?.length === 0 && (
                                <>
                                  <div className="img_card">
                                    <img src={avatar} />
                                  </div>
                                  <div className="img_card">
                                    <img src={avatar} />
                                  </div>
                                </>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Categories | stylepro</title>
        </MetaTags>
        {/* <Spinner loading={loading} /> */}
        <Container fluid id="service_list">
          <Breadcrumbs title="Categories" breadcrumbItem="Categories List" />
          <BreadcrumbSub
            subtile="Categories List"
            SubBreadcrumbItem="Categories"
          />
          <Row>
            <Col className="tab_1 px-0 me-2">
              <Card className="border-light">
                <CardBody className="px-3">
                  {genders.map(gender => (
                    <div
                      key={gender.key}
                      className={`avatar-card ${
                        selectedGender === gender.label ? "selected" : ""
                      }`}
                      onClick={() => handleGenderSelect(gender.label)}
                      type="button"
                    >
                      <img
                        src={gender.image}
                        alt={gender.label}
                        className="avatar-image"
                      />
                      <p className="mt-2 fw-bold">{gender.label}</p>
                    </div>
                  ))}
                </CardBody>
              </Card>
            </Col>
            <Col className=" tab_2 px-0 me-2">{renderParentCatList()}</Col>
            <Col className="tab_3">
              {activeSubCatInd !== null && (
                <div className="text-end">
                  <Button
                    type="button"
                    color="primary"
                    className="btn-sm mb-2 px-4"
                    onClick={toggle}
                  >
                    <i className="bx bx-user-plus me-1" />
                    Create New
                  </Button>
                </div>
              )}
              <Card className="border-light">
                {/* {activeSubCatInd !== null &&
                  subCatList &&
                  subCatList.length > 0 && (
                    <div className="service_title">
                      {parentCatList[activeParentCatInd]["name"]}
                    </div>
                  )} */}
                <div>
                  <div className="services_tabs p-3 pb-0">
                    {!subCatList && (
                      <div className="empty_list p-3 pt-0">
                        <div className="text-center">
                          <i
                            className="mdi mdi-arrow-left-circle"
                            id="nullCatList"
                          ></i>
                        </div>
                        <p className="text-center">Please Select Category</p>
                      </div>
                    )}
                    {subCatList && subCatList.length === 0 && (
                      <div className="empty_list p-3 pt-0">
                        <div className="text-center">
                          <i
                            className="mdi mdi-circle-off-outline"
                            id="EmptyCatList"
                          ></i>
                        </div>
                        <h4>Empty List</h4>
                        <p className="text-center">No Services Found</p>
                      </div>
                    )}
                    {subCatList &&
                      subCatList.map((ele, indx) => {
                        return (
                          <button
                            key={indx}
                            className={
                              activeServiceInd === indx
                                ? "me-3 mb-3 px-3 py-1 active"
                                : "me-3 mb-3 px-3 py-1"
                            }
                            onClick={() => {
                              handleService(ele, indx);
                            }}
                          >
                            {ele.title}
                          </button>
                        );
                      })}
                  </div>
                  {activeServiceInd !== null && service && (
                    <div className="service_view_container">
                      {renderBasicInfo()}
                    </div>
                  )}

                  {subCatList?.length > 0 && activeServiceInd === null && (
                    <div className="empty_list p-3 pt-0 mt-2 border-light">
                      <div className="text-center">
                        <i
                          className="mdi mdi-arrow-up-circle"
                          id="nullCatList"
                        ></i>
                      </div>
                      <p className="text-center">Please Select Category</p>
                    </div>
                  )}
                  {/* </div> */}
                  {delete_modal ? deletePopup() : null}
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Create Service Modal  */}
      {modal && (
        <CreateCategory
          toggle={toggle}
          modal={modal}
          reload={getCategoriesList}
          activeParentCatInd={
            parentCatList[activeParentCatInd]
              ? parentCatList[activeParentCatInd]
              : {}
          }
        />
      )}
      {Editmodal && (
        <EditCategory
          toggle={EditToggle}
          modal={Editmodal}
          SelectedCatdata={activeService}
          reload={getCategoriesList}
          activeParentCatInd={
            parentCatList[activeParentCatInd]
              ? parentCatList[activeParentCatInd]
              : {}
          }
        />
      )}
    </React.Fragment>
  );
};

export default CategoriesMain;
